import script from "./SaleSectionProvisions.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleSectionProvisions.vue?vue&type=script&setup=true&lang=js"

import "./SaleSectionProvisions.vue?vue&type=style&index=0&id=3a28d716&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a28d716"]])

export default __exports__